"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.CrewStyle;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.hair);
    messageWriter_sidecar_1.messageWriter.write32(m, d.hairColor);
    messageWriter_sidecar_1.messageWriter.write32(m, d.body);
    messageWriter_sidecar_1.messageWriter.write32(m, d.bodyColor);
    messageWriter_sidecar_1.messageWriter.write32(m, d.head);
    messageWriter_sidecar_1.messageWriter.write32(m, d.headColor);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        hair: messageWriter_sidecar_1.messageWriter.read32(m),
        hairColor: messageWriter_sidecar_1.messageWriter.read32(m),
        body: messageWriter_sidecar_1.messageWriter.read32(m),
        bodyColor: messageWriter_sidecar_1.messageWriter.read32(m),
        head: messageWriter_sidecar_1.messageWriter.read32(m),
        headColor: messageWriter_sidecar_1.messageWriter.read32(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        crewId: 100,
        hair: 123,
        hairColor: 0x123456,
        body: 34,
        bodyColor: 0x323345,
        head: 2,
        headColor: 0x243421,
    };
    messageWriter_sidecar_1.messageWriter.test('crew-style', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    var cr = diveCrew_sidecar_1.diveCrew.findById(msg.crewId);
    // if (cr && cr.crewState && cr.crewState.body) {
    //   let b = cr.crewState.body
    //   voyageBodies.setBody(b, voyageBodiesData.bodies[msg.body])
    //   b.imageBody.tint = msg.bodyColor
    //   voyageBodies.setHair(b, voyageBodiesData.hairs[msg.hair])
    //   b.imageHair.tint = msg.hairColor
    //   voyageBodies.setHead(b, voyageBodiesData.heads[msg.head])
    //   b.imageHead.tint = msg.headColor
    // }
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
